<script setup lang="ts">
import { computed } from 'vue';

import * as commonConstants from '@/constants/common';

export interface Props {
  size?: number;
  background?: string;
  color?: string;
  text?: string;
  imageURL?: string | null;
  newImage?: string;
}
const props = withDefaults(defineProps<Props>(), {
  size: 64,
  background: 'purple',
  color: 'white',
  text: 'ME',
  imageURL: undefined,
  newImage: undefined,
});

const url = import.meta.env.VITE_APP_API?.replace(/\/api\//i, '') || '';

const formattedUrl = computed(() => {
  return url + (props.imageURL ?? '');
});

const formattedText = computed(() => {
  return props.text.replace(/"/, '')[0].toUpperCase();
});
</script>

<template>
  <v-avatar
    :class="[
      $style.avatar,
      {
        [$style.colorWhite]: props.color === 'white',
        [$style.colorPurple]: props.color === 'purple',
        [$style.colorGreen]: props.color === 'green',
      },
      {
        [$style.bgPurple]: props.background === 'purple',
        [$style.bgGreen]: props.background === 'green',
      },
    ]"
    :size="props.size"
  >
    <img
      v-if="props.imageURL || props.newImage"
      :src="props.newImage ? props.newImage : formattedUrl"
      alt="Avatar"
      :class="$style.image"
    />
    <span v-else :style="`font-size: ${props.size / 1.5}px`">
      {{ props.text ? formattedText : commonConstants.EM_DASH }}
    </span>
  </v-avatar>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.avatar {
  width: 64px;
  height: 64px;

  &.colorWhite {
    color: colors.$color-white;
  }
  &.colorPurple {
    color: colors.$color-brand-800;
  }
  &.colorGreen {
    color: colors.$color-green-500;
  }
  &.bgPurple {
    background-color: colors.$color-brand-100;
  }
  &.bgGreen {
    background-color: colors.$color-green-500;
  }
}
  .image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
